var map = {
	"./accounts.svg": "./icons/accounts.svg",
	"./action-menu.svg": "./icons/action-menu.svg",
	"./add-category.svg": "./icons/add-category.svg",
	"./add.svg": "./icons/add.svg",
	"./addlink.svg": "./icons/addlink.svg",
	"./archive.svg": "./icons/archive.svg",
	"./arrow-left.svg": "./icons/arrow-left.svg",
	"./arrow-right.svg": "./icons/arrow-right.svg",
	"./ascending.svg": "./icons/ascending.svg",
	"./asset.svg": "./icons/asset.svg",
	"./attachment.svg": "./icons/attachment.svg",
	"./back.svg": "./icons/back.svg",
	"./bookmark.svg": "./icons/bookmark.svg",
	"./bug-report.svg": "./icons/bug-report.svg",
	"./calendar.svg": "./icons/calendar.svg",
	"./carousel.svg": "./icons/carousel.svg",
	"./catch-up.svg": "./icons/catch-up.svg",
	"./category-with-assets.svg": "./icons/category-with-assets.svg",
	"./category.svg": "./icons/category.svg",
	"./check.svg": "./icons/check.svg",
	"./checkbox-checked.svg": "./icons/checkbox-checked.svg",
	"./checkbox-indeterminate.svg": "./icons/checkbox-indeterminate.svg",
	"./checkbox-unchecked.svg": "./icons/checkbox-unchecked.svg",
	"./chromecast.svg": "./icons/chromecast.svg",
	"./close.svg": "./icons/close.svg",
	"./collapse.svg": "./icons/collapse.svg",
	"./comment.svg": "./icons/comment.svg",
	"./content.svg": "./icons/content.svg",
	"./contract-accepted.svg": "./icons/contract-accepted.svg",
	"./contract.svg": "./icons/contract.svg",
	"./copy.svg": "./icons/copy.svg",
	"./crop.svg": "./icons/crop.svg",
	"./curated-asset.svg": "./icons/curated-asset.svg",
	"./curated-category.svg": "./icons/curated-category.svg",
	"./curation.svg": "./icons/curation.svg",
	"./data.svg": "./icons/data.svg",
	"./delete.svg": "./icons/delete.svg",
	"./descending.svg": "./icons/descending.svg",
	"./disable.svg": "./icons/disable.svg",
	"./document-conflict.svg": "./icons/document-conflict.svg",
	"./down.svg": "./icons/down.svg",
	"./download.svg": "./icons/download.svg",
	"./dropdown.svg": "./icons/dropdown.svg",
	"./duplicate.svg": "./icons/duplicate.svg",
	"./edit.svg": "./icons/edit.svg",
	"./empty.svg": "./icons/empty.svg",
	"./error.svg": "./icons/error.svg",
	"./execute.svg": "./icons/execute.svg",
	"./exit-fullscreen.svg": "./icons/exit-fullscreen.svg",
	"./expand.svg": "./icons/expand.svg",
	"./external-link.svg": "./icons/external-link.svg",
	"./face.svg": "./icons/face.svg",
	"./feed.svg": "./icons/feed.svg",
	"./filter.svg": "./icons/filter.svg",
	"./folder-asset.svg": "./icons/folder-asset.svg",
	"./folder-tab.svg": "./icons/folder-tab.svg",
	"./folder-up.svg": "./icons/folder-up.svg",
	"./folder.svg": "./icons/folder.svg",
	"./forward.svg": "./icons/forward.svg",
	"./free.svg": "./icons/free.svg",
	"./fullscreen.svg": "./icons/fullscreen.svg",
	"./globe.svg": "./icons/globe.svg",
	"./goto-end.svg": "./icons/goto-end.svg",
	"./goto-last.svg": "./icons/goto-last.svg",
	"./goto-mark-in.svg": "./icons/goto-mark-in.svg",
	"./goto-mark-out.svg": "./icons/goto-mark-out.svg",
	"./goto-start.svg": "./icons/goto-start.svg",
	"./help.svg": "./icons/help.svg",
	"./hidden.svg": "./icons/hidden.svg",
	"./hierarchy.svg": "./icons/hierarchy.svg",
	"./home.svg": "./icons/home.svg",
	"./image.svg": "./icons/image.svg",
	"./images.svg": "./icons/images.svg",
	"./index-marker.svg": "./icons/index-marker.svg",
	"./info.svg": "./icons/info.svg",
	"./insights.svg": "./icons/insights.svg",
	"./io.svg": "./icons/io.svg",
	"./left-mouse-click.svg": "./icons/left-mouse-click.svg",
	"./link-with-metadata.svg": "./icons/link-with-metadata.svg",
	"./link.svg": "./icons/link.svg",
	"./list_smart.svg": "./icons/list_smart.svg",
	"./live-asset.svg": "./icons/live-asset.svg",
	"./live-lcp.svg": "./icons/live-lcp.svg",
	"./live-tv.svg": "./icons/live-tv.svg",
	"./live.svg": "./icons/live.svg",
	"./lock-open.svg": "./icons/lock-open.svg",
	"./lock.svg": "./icons/lock.svg",
	"./mark-in.svg": "./icons/mark-in.svg",
	"./mark-out.svg": "./icons/mark-out.svg",
	"./menu-item.svg": "./icons/menu-item.svg",
	"./menu.svg": "./icons/menu.svg",
	"./microphone.svg": "./icons/microphone.svg",
	"./monetise.svg": "./icons/monetise.svg",
	"./monetization.svg": "./icons/monetization.svg",
	"./money.svg": "./icons/money.svg",
	"./movie.svg": "./icons/movie.svg",
	"./music-note.svg": "./icons/music-note.svg",
	"./notification.svg": "./icons/notification.svg",
	"./ok.svg": "./icons/ok.svg",
	"./orchestrate.svg": "./icons/orchestrate.svg",
	"./page.svg": "./icons/page.svg",
	"./pause-regular.svg": "./icons/pause-regular.svg",
	"./pause.svg": "./icons/pause.svg",
	"./pin.svg": "./icons/pin.svg",
	"./pinview.svg": "./icons/pinview.svg",
	"./play-arrow.svg": "./icons/play-arrow.svg",
	"./play-outlined.svg": "./icons/play-outlined.svg",
	"./play.svg": "./icons/play.svg",
	"./plugin.svg": "./icons/plugin.svg",
	"./products.svg": "./icons/products.svg",
	"./profiles.svg": "./icons/profiles.svg",
	"./publish.svg": "./icons/publish.svg",
	"./radiobutton-checked.svg": "./icons/radiobutton-checked.svg",
	"./radiobutton-unchecked.svg": "./icons/radiobutton-unchecked.svg",
	"./related.svg": "./icons/related.svg",
	"./reset.svg": "./icons/reset.svg",
	"./revert.svg": "./icons/revert.svg",
	"./rewind.svg": "./icons/rewind.svg",
	"./rights-manager.svg": "./icons/rights-manager.svg",
	"./schedule.svg": "./icons/schedule.svg",
	"./search.svg": "./icons/search.svg",
	"./settings.svg": "./icons/settings.svg",
	"./shop.svg": "./icons/shop.svg",
	"./source.svg": "./icons/source.svg",
	"./speedometer.svg": "./icons/speedometer.svg",
	"./star.svg": "./icons/star.svg",
	"./stop.svg": "./icons/stop.svg",
	"./storage.svg": "./icons/storage.svg",
	"./success.svg": "./icons/success.svg",
	"./tab.svg": "./icons/tab.svg",
	"./thumbnail.svg": "./icons/thumbnail.svg",
	"./time.svg": "./icons/time.svg",
	"./transition-vod.svg": "./icons/transition-vod.svg",
	"./unarchive.svg": "./icons/unarchive.svg",
	"./unlink-linked-metadata.svg": "./icons/unlink-linked-metadata.svg",
	"./unlink.svg": "./icons/unlink.svg",
	"./unpublish.svg": "./icons/unpublish.svg",
	"./up.svg": "./icons/up.svg",
	"./upload.svg": "./icons/upload.svg",
	"./url.svg": "./icons/url.svg",
	"./user.svg": "./icons/user.svg",
	"./users.svg": "./icons/users.svg",
	"./versions.svg": "./icons/versions.svg",
	"./via-live-v2.svg": "./icons/via-live-v2.svg",
	"./via.svg": "./icons/via.svg",
	"./view.svg": "./icons/view.svg",
	"./vimond.svg": "./icons/vimond.svg",
	"./visible.svg": "./icons/visible.svg",
	"./volume-down.svg": "./icons/volume-down.svg",
	"./volume-off.svg": "./icons/volume-off.svg",
	"./volume-up.svg": "./icons/volume-up.svg",
	"./warning.svg": "./icons/warning.svg",
	"./zoom-in.svg": "./icons/zoom-in.svg",
	"./zoom-out.svg": "./icons/zoom-out.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./icons sync recursive ^\\.\\/.*\\.svg$";